<template>
  <div class="records">
    <div class="task-side">
      <div class="task-side-title">品种研发</div>
      <div class="land-tab">
        <div :class="['land-tab-items', item.cid === tabIndex ? 'active' : '']" v-for="item in tabList" :key="item.cid" @click="changTab(item)">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="main">
      <PageTop
        :varietyShow="true"
        :addShow="true"
        :addShow2="true"
        @addMeans="addRecords"
        @showAddAlert="showAddAlert"
        @getVarietySearch="getVarietySearch"
      >
        <p slot="addName">添加记录</p>
        <p slot="addName2">文件导入</p>
      </PageTop>
      <div class="task-main">
        <MyTable class="animated fadeInUp" :tableData="recordList" :configTable="configTable" @handleDelete="handleDelete" @handleEdit="handleEdit" />
        <el-pagination background layout="prev, pager, next" :page-size="20" :total="total" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
    <el-dialog
      class="big-pop"
      title=" "
      :visible.sync="addShow"
      width="671px"
      :before-close="setAddClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="big-main">
        <div class="ware-title">
          <div class="left-line"></div>
          {{ popTitle }}
        </div>
        <div class="add-form">
          <el-form :model="form" ref="form" :rules="rules" hide-required-asterisk>
            <el-form-item label="时间" :label-width="formLabelWidth" prop="date">
              <el-date-picker v-model="form.date" type="date" placeholder="请选择时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="品名(通用名)" :label-width="formLabelWidth" prop="p_name">
              <el-input v-model.trim="form.p_name" placeholder="请输入品名（通用名）" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="购买地点" :label-width="formLabelWidth" prop="address">
              <el-input v-model.trim="form.address" placeholder="请输入购买地点"></el-input>
            </el-form-item>
            <el-form-item label="生产企业" :label-width="formLabelWidth" prop="company">
              <el-input v-model.trim="form.company" placeholder="请输入生产企业"></el-input>
            </el-form-item>
            <el-form-item label="登记证号" :label-width="formLabelWidth" prop="number">
              <el-input v-model.trim="form.number" placeholder="请输入登记证号"></el-input>
            </el-form-item>
            <el-form-item label="购入量" :label-width="formLabelWidth" prop="num">
              <el-input v-model.number.trim="form.num" placeholder="请输入购入量" maxlength="20"></el-input>
            </el-form-item>

            <!-- <el-form-item label="上传图片" :label-width="formLabelWidth" prop="cover">
              <el-upload
                :class="['uploadCover', form.file_path ? 'active' : '']"
                action="http://36.34.175.124:8801/project/digital2/api/file/upload"
                :data="{
                  manor_id: farmID,
                  mid: userInfo.id
                }"
                :limit="1"
                list-type="picture-card"
                :show-file-list="true"
                :file-list="fileList"
                :headers="uploadHeaders"
                :on-success="handleAvatarSuccess"
                :on-error="handleAvatarFail"
                :on-remove="removeFile"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item> -->

            <el-form-item label="经办人" :label-width="formLabelWidth" prop="mid">
              <el-select v-model="form.mid" placeholder="选择经办人" v-loadMore="loadMoreUserNameData">
                <el-option :label="item.user_name" :value="item.mid" v-for="item in userNameList" :key="item.mid"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="所属类型" :label-width="formLabelWidth" prop="title">
              <el-select v-model="form.title" placeholder="请选择所属类型">
                <el-option :label="item" :value="item" v-for="(item, index) in tabList" :key="index"></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
              <el-input v-model.trim="form.remark" type="textarea" placeholder="请输入备注" maxlength="200"> </el-input>
            </el-form-item>
            <el-form-item label=" " class="dialog-footer">
              <el-button class="ok-button" type="primary" @click="okAdd('form')">确 定</el-button>
              <el-button class="no-button" @click="noAdd('form')">取 消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <!-- 文件导入 -->
    <el-dialog
      class="big-pop small-pop"
      title=" "
      :visible.sync="fileImportShow"
      width="598px"
      :before-close="setFileImportClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="big-main">
        <div class="ware-title">
          <div class="left-line"></div>
          文件导入
        </div>
        <div class="add-form">
          <el-form hide-required-asterisk label-position="top">
            <el-form-item label="" prop="cover">
              <el-upload
                ref="uploadFileRef"
                action="http://36.34.175.124:8801/project/digital2/hanshan/variety/add"
                accept=".xlsx,.xls,.csv"
                :data="{
                  cid: tabIndex
                }"
                :limit="1"
                :file-list="addFileList"
                :headers="uploadHeaders"
                :auto-upload="false"
                :on-exceed="handleFileExceed"
                :on-error="handleFileFail"
                :on-success="handleFileSuccess"
              >
                <el-button slot="trigger" type="primary">选取文件</el-button>
                <el-button style="margin-left: 20px" type="success" @click="submitUpload">文件导入</el-button>
                <div slot="tip" class="el-upload__tip">只能上传Excel/CSV文件</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { editTime3 } from '@/utils/editTime'

import {
  getVarietyListApi,
  editHanshanRecordApi,
  addHanshanRecordApi,
  delVarietyApi,
  getVarietyClassListApi,
  getHanshanUserListApi
} from '@/request/api.js'
export default {
  components: {
    PageTop: () => import('@/components/PageTop.vue'),
    MyTable: () => import('@/components/MyTable.vue')
  },
  name: 'viewRecords',
  data() {
    return {
      fileImportShow: false,
      addShow: false,
      popTitle: '',
      mid: '',
      date: '',

      form: {
        date: '',
        p_name: '',
        address: '',
        company: '',
        number: '',
        num: '',
        mname: '',
        remark: ''
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'change' }],
        p_name: [{ required: true, message: '请输入品名', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        company: [{ required: true, message: '请输入企业', trigger: 'blur' }],
        number: [{ required: true, message: '请输入证号', trigger: 'blur' }],
        num: [{ required: true, message: '请输入购入量', trigger: 'blur' }],
        mname: [{ required: true, message: '请选择经办人', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      },
      formLabelWidth: '120px',
      fileList: [],
      addFileList: [],
      uploadHeaders: {
        Authorization: localStorage.getItem('darsingToken')
      },
      tabList: [],
      title: '',
      tabIndex: 0,
      configTable: [
        {
          prop: 'date',
          label: '时间',
          width: '118'
        },
        {
          prop: 'p_name',
          label: '品名（通用名）',
          width: '160'
        },
        {
          prop: 'address',
          label: '购买地点',
          width: '200'
        },
        {
          prop: 'company',
          label: '生产企业',
          width: '160'
        },
        {
          prop: 'number',
          label: '登记证号',
          width: '160'
        },
        {
          prop: 'num',
          label: '购入量',
          width: '160'
        },
        {
          prop: 'mname',
          label: '经办人',
          width: '160'
        },
        {
          prop: 'remark',
          label: '备注',
          width: '160'
        },

        {
          prop: '',
          label: '操作',
          width: '',
          delType: true,
          editType: true
        }
      ],
      pn: 1,
      ps: 10,
      total: 0,
      recordList: [],
      userNameList: [],
      userNameTotal: 10,
      userNameCurrent_page: 1
    }
  },
  computed: {
    ...mapState({
      farmID: (state) => state.user.farmID,
      uploadImgs: (state) => state.app.uploadImgs,
      userInfo: (state) => state.user.userInfo
    })
  },
  created() {
    this.getVarietyClassList()
  },
  watch: {
    addShow(value) {
      if (!value) {
        this.form = {}
        this.fileList = []
        this.getList()
      }
    }
  },
  methods: {
    loadMoreUserNameData() {
      if (this.userNameList.length && this.userNameList.length == this.userNameTotal) return
      this.userNameCurrent_page++
      this.getHanshanUserList(this.userNameCurrent_page)
    },
    async getHanshanUserList(pn = 1) {
      const { code, results } = await getHanshanUserListApi({
        manor_id: +this.farmID,
        pn
      })
      if (code === 0) {
        this.userNameList = [...this.userNameList, ...results.data]
        this.userNameTotal = results.count
        this.userNameCurrent_page = results.pn
      }
    },
    submitUpload() {
      this.$refs.uploadFileRef.submit()
    },
    noAdd(formName) {
      this.addShow = false
      this.$refs[formName].resetFields()
    },

    addFileImport(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        // if (this.popTitle === '添加记录') {
        //   this.addRecord()
        // } else {
        //   this.editRecord()
        // }
      })
    },
    okAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        if (this.popTitle === '添加记录') {
          this.addRecord()
        } else {
          this.editRecord()
        }
      })
    },
    async editRecord() {
      this.form.date = editTime3(this.form.date)
      const { code } = await editHanshanRecordApi({
        manor_id: +this.farmID,
        record_id: this.form.id,
        ...this.form
      })
      if (code !== 0) return
      this.addShow = false
      this.$notify({
        title: '成功',
        message: '已修改',
        type: 'success'
      })
    },
    async addRecord() {
      this.form.date = editTime3(this.form.date)
      const { code } = await addHanshanRecordApi({
        manor_id: +this.farmID,
        ...this.form
      })
      if (code !== 0) return
      this.addShow = false
      this.$notify({
        title: '成功',
        message: '已添加',
        type: 'success'
      })
    },
    setAddClose() {
      this.addShow = false
    },
    setFileImportClose() {
      this.addFileList = []
      this.fileImportShow = false
    },
    async handleEdit(row) {
      if (row.file_path) {
        this.fileList = [
          {
            url: this.uploadImgs + row.file_path
          }
        ]
      }
      this.form = row
      this.popTitle = '编辑记录'
      this.addShow = true
    },
    addRecords() {
      this.popTitle = '添加记录'
      this.addShow = true
    },
    showAddAlert() {
      this.fileImportShow = true
    },
    removeFile() {
      this.form.file_path = ''
    },
    handleFileFail(err) {
      console.log(err)

      this.$notify.error({
        title: '错误',
        message: '上传失败，稍后尝试'
      })
    },
    handleAvatarFail() {
      this.$notify.error({
        title: '错误',
        message: '上传失败，稍后尝试'
      })
    },
    handleFileExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },

    handleFileSuccess(res, file) {
      if (file.percentage === 100) {
        this.addFileList = []
        this.getList()
        this.fileImportShow = false
        this.$notify({
          title: '成功',
          message: '文件已导入',
          type: 'success'
        })
      }
    },
    handleAvatarSuccess(res, file) {
      if (file.percentage === 100) {
        this.form.file_path = file.response.data.file_path
        this.$notify({
          title: '成功',
          message: '上传成功',
          type: 'success'
        })
      }
    },
    getVarietySearch({ date, mid }) {
      this.date = date
      this.mid = mid
      this.pn = 1
      this.getList()
    },
    async getVarietyClassList() {
      const { code, results } = await getVarietyClassListApi({
        ps: 100
      })
      if (code != 0) return
      this.tabList = results.data
      this.tabIndex = results.data[0].cid
      this.title = results.data[0].name
      this.getList()
    },
    async getList() {
      const { code, results } = await getVarietyListApi({
        // manor_id: +this.farmID,
        mid: this.mid,
        date: this.date,
        cid: this.tabIndex,
        pn: this.pn
      })
      if (code != 0) return
      this.recordList = results.data
      this.total = results.count
      this.pn = results.pn
      this.ps = results.ps
    },
    changTab(item) {
      this.tabIndex = item.cid
      this.title = item.name
      this.pn = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pn = val
      this.getList()
    },
    handleDelete({ id }) {
      this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const { code } = await delVarietyApi({ id })
          if (code === 0) {
            this.getList()
            this.$notify({
              title: '提示',
              message: '已删除',
              type: 'success'
            })
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">
.records {
  width: 100%;
  min-height: 100vh;
  background-color: #071a2c;
  padding: 0 48px 100px;
  display: flex;
  justify-content: space-between;
  .task-side {
    width: 312px;
    height: 98%;
    background: #142d4c;
    padding: 34px 21px;
    margin-top: 16px;
    .task-side-title {
      width: 100%;
      line-height: 22px;
      height: 22px;
      font-size: 22px;
      font-weight: bold;
      color: #fff;
      padding-left: 11px;
      border-left: 4px solid #3e90e5;
      border-radius: 2px;
      margin-bottom: 27px;
    }

    .land-tab {
      width: 100%;
      height: 60%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 2px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #3e90e5;
      }
      .land-tab-items {
        width: 100%;
        height: 32px;
        text-align: center;
        line-height: 32px;
        background: #173355;
        border: 1px solid #1b3e68;
        border-radius: 2px;
        font-size: 14px;
        color: #fff;
        margin-bottom: 18px;
        cursor: pointer;
        &.active {
          background-color: #3e90e5;
        }
      }
    }
  }
  .main {
    width: calc(100% - 328px);
    /deep/.land-admin {
      height: auto;
    }
  }
  .big-pop {
    /deep/.el-dialog {
      width: 671px !important;
      background-color: inherit;
    }

    /deep/.el-dialog__body {
      padding: 0;
    }

    /deep/.el-dialog__headerbtn {
      font-size: 26px;
      top: 64px;
      right: 50px;
      font-weight: bold;
    }
  }
  .big-pop.small-pop {
    /deep/.el-dialog {
      width: 598px !important;
    }
  }

  .big-pop {
    /deep/.el-form-item {
      margin-bottom: 32px;
    }

    /deep/.el-button span {
      color: #fff;
    }

    /deep/.el-dialog__headerbtn {
      top: 71px;
      right: 44px;
    }

    /deep/.dialog-footer {
      margin-top: 40px;
      padding: 0 0 0 119px;
    }

    .ok-button {
      width: 150px;
      height: 40px;
      margin-right: 44px;
    }

    .no-button {
      width: 150px;
      height: 40px;
      border: 1px solid #385576;
      background-color: #0f243d;
    }

    .big-main {
      width: 671px;
      height: 859px;
      background: url('../../assets/image/records/bg.png') no-repeat center center;

      background-size: cover;
      padding: 45px 55px;
      overflow: hidden;
      .ware-title {
        font-size: 22px;
        color: #fff;
        font-weight: bold;
        display: flex;
        margin-bottom: 40px;
        align-items: center;
        .left-line {
          background-color: #fff;
          width: 4px;
          height: 21px;
          border-radius: 3px;
          margin-right: 10px;
        }
      }

      .block {
        width: 100%;
        height: calc(100% - 124px);
        overflow: auto;
        padding: 0 2px;

        &::-webkit-scrollbar {
          width: 1px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #ccc;
        }
      }
      /deep/.uploadCover {
        width: 158px;
        height: 105px;
        display: flex;
        .el-upload--picture-card {
          width: 100%;
          height: 100%;
          line-height: 105px;
        }
        .el-upload-list--picture-card .el-upload-list__item {
          width: 158px;
          height: 105px;
        }
        &.active {
          .el-upload--picture-card {
            display: none;
          }
        }
      }
      /deep/.el-card {
        background-color: #081c30;
        border: none;
      }

      /deep/.el-timeline-item__tail {
        border-left: 2px solid #385576;
      }

      /deep/.el-timeline-item__timestamp {
        font-size: 18px;
        color: #fff;
      }

      /deep/.el-card__body {
        width: 450px;
        min-height: 83px;
        padding: 18px 15px;
      }

      /deep/.el-timeline-item__node {
        background-color: #67c23a;
      }

      /deep/.el-timeline-item.active {
        .el-timeline-item__node {
          background-color: #e60000;
        }
      }

      .info-col1 {
        margin-bottom: 16px;

        span {
          font-size: 18px;
          color: #fff;
          margin-right: 16px;
        }

        .num {
          color: #e60000;
        }

        .num.active {
          color: #67c23a;
        }
      }

      .info-col2 {
        span {
          font-size: 14px;
        }

        .text1 {
          color: #57708d;
          margin-right: 14px;
        }

        .text2 {
          color: #fff;
          margin-right: 20px;
        }

        .text3 {
          color: #57708d;
          margin-right: 10px;
        }

        .text4 {
          color: #3e90e5;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      /deep/.el-input__inner {
        background-color: #081c30;
        border: 1px solid #385576;
        color: #57708d;
        width: 353px;
      }

      /deep/.el-textarea__inner {
        background-color: #081c30;
        border: 1px solid #385576;
        color: #57708d;
        width: 353px;
        height: 120px;
        resize: none;
      }

      /deep/.el-form-item__label {
        font-size: 14px;
        color: #fff;
        padding: 0 24px 0 0;
      }

      /deep/.el-radio__input.is-checked + .el-radio__label {
        color: #fff;
      }

      /deep/.el-radio {
        color: #fff;
      }
      .add-form {
        width: 100%;
        height: calc(100% - 56px);
        overflow-y: scroll;
        &::-webkit-scrollbar {
          width: 7px;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #3e90e5;
        }
      }
    }
  }
  .big-pop.small-pop {
    .big-main {
      width: 598px;
      height: 539px;
      background: url(../../assets/image/configure/process/addbgimg.png) no-repeat center center;
    }
  }
}
</style>
